import { AsyncComponentFactory } from 'vue/types/options';

export const DevtoolsAsync: AsyncComponentFactory = () => ({
  component: import('./devtools.vue') as any,
  delay: 200,
  timeout: 3000,
});
